import './style.css'
import * as THREE from 'three'
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import {AdditiveBlending, BufferAttribute, BufferGeometry, Fog, Points, PointsMaterial, SphereGeometry} from "three";

/**
 * Base
 */
// Debug
const gui = new dat.GUI()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const particleTexture = textureLoader.load("/textures/particles/2.png");

/**
 * Particles
 */

const params = {
    count: 500_000,
    spin: 1,
    strands: 3,
    particleSize: 0.01,
    radius: 10,
    branches: 3,
    spread: 2,
    rotating: false,
};

let geometry;
let points;
let material;

const generateGalaxy = () => {
    if (points) {
        geometry.dispose();
        material.dispose();
        scene.clear()
    }
    /**
     * Geometry
     */

    geometry = new BufferGeometry();
    const positions = new Float32Array(params.count * 3);
    const colors = new Float32Array(params.count * 3);

    for (let i = 0; i < params.count * 3; i += 3) {
        const angle = ((i / 3) % params.branches) / params.branches * Math.PI * 2;

        const dist = Math.pow(Math.random(), 2) * params.radius;

        const x = Math.sin(angle + dist * params.spin) * dist;
        const y = 0;
        const z = Math.cos(angle + dist * params.spin) * dist;

        let xOffset = Math.random() - 0.5;
        let yOffset = Math.random() - 0.5;
        let zOffset = Math.random() - 0.5;

        const offsetLength = Math.sqrt(xOffset**2 + yOffset**2 + zOffset**2);
        const desiredLength = Math.random()*params.spread;
        xOffset *= desiredLength/offsetLength;
        yOffset *= desiredLength/offsetLength;
        zOffset *= desiredLength/offsetLength;


        positions[i] = x + xOffset;
        positions[i + 1] = y + yOffset;
        positions[i + 2] = z + zOffset;

        colors[i] = 1- dist/params.radius
        colors[i + 1] = Math.max(0, 0.3-dist/params.radius)
        colors[i + 2] = dist/params.radius
    }

    geometry.setAttribute(
        "position",
        new BufferAttribute(positions, 3),
    )

    geometry.setAttribute(
        "color",
        new BufferAttribute(colors, 3),
    )

    /**
     * Material
     */
    material = new PointsMaterial({
        size: params.particleSize,
        // map: particleTexture,
        // alphaTest: 0.1,
        // alphaMap: particleTexture,
        // transparent: true,
        depthWrite: false,
        blending: AdditiveBlending,
        vertexColors: true,
    });

    points = new Points(geometry, material);
    scene.add(points)
}
generateGalaxy();

gui.add(params, "particleSize").min(0.0001).max(0.05).step(0.001).onFinishChange(generateGalaxy);
gui.add(params, "count").min(10).max(2_000_000).step(1).onFinishChange(generateGalaxy);
gui.add(params, "radius").min(1).max(20).step(0.01).onFinishChange(generateGalaxy);
gui.add(params, "branches").min(1).max(10).step(1).onFinishChange(generateGalaxy);
gui.add(params, "spin").min(0).max(2).step(0.01).onFinishChange(generateGalaxy);
gui.add(params, "spread").min(0).max(5).step(0.01).onFinishChange(generateGalaxy);
gui.add(params, "rotating");


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 7
camera.position.y = 5
scene.add(camera)

const fog = new Fog("#000", 0, 5);
// scene.fog = fog;

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    if(params.rotating){
        points.rotation.y = elapsedTime*-0.1
    }
    // for (let i = 0; i < count * 3; i += 3) {
    //     const pos =  particles.geometry.attributes.position.array;
    //     pos[i + 1] = Math.sin(elapsedTime+pos[i]+pos[i+2]);
    //     const col = particles.geometry.attributes.color.array;
    //     col[i] = Math.sin(elapsedTime+pos[i]+pos[i+2])/2+0.5;
    //     col[i+1] = Math.sin(elapsedTime+pos[i]+pos[i+2])/2+0.5;
    // }
    // particles.geometry.attributes.position.needsUpdate = true;
    // particles.geometry.attributes.color.needsUpdate = true;
    // particles.rotation.y = elapsedTime*0.1;

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()